/**
 * useRealtimeTaskAssignments(userId)
 *
 * Subscribes to INSERT and UPDATE on public.cleaning_tasks scoped to
 * the given assignee. Invalidates the my-tasks list and the per-task
 * detail query so the cleaner sees a new assignment or a status flip
 * (e.g. supervisor approval) without manually refreshing.
 *
 * No-op while userId is unknown — safe to mount unconditionally.
 */

import { useRealtimeSubscription } from './useRealtimeSubscription'

export function useRealtimeTaskAssignments(userId: string | null | undefined): void {
  useRealtimeSubscription({
    channelName:    `task-assignments-${userId ?? 'unauth'}`,
    table:          'cleaning_tasks',
    filter:         userId ? `assigned_to_user_id=eq.${userId}` : undefined,
    events:         ['INSERT', 'UPDATE'],
    invalidateKeys: [
      ['my-tasks'],
      ['my-tasks', userId ?? null],
    ],
    enabled:        !!userId,
  })
}
